import { filterText } from "./filterDomain";
import { serializeCause } from "./logDomain";
import { SerializedError } from "./serializeDomain";

export type ErrorSource = "window.onerror" | "unhandledrejection" | "error_boundary";

export type ErrorLocation = {
  file?: string;
  line?: number;
  column?: number;
  componentStack?: string;
};

export type ErrorData = ErrorLocation & {
  source: ErrorSource;
  message: string;
  error?: SerializedError;
  cause?: unknown;
};

export function toErrorData(
  source: ErrorSource,
  error: unknown,
  message: string,
  location: ErrorLocation,
): ErrorData {
  return { source, message: filterText(message), ...serializeCause(error), ...location };
}
